<template>
    <b-overlay :show="isLoading">
        <b-container fluid>
            <b-card class="m-4">
                <template #header>
                    <div class="text-right">
                        <b-button variant="outline-secondary" :to="{ name: 'Customer' }" class="mr-2">
                            <font-awesome-icon icon="angle-left"></font-awesome-icon> Regresar
                        </b-button>
                        <b-button variant="primary" :to="{ name: 'CustomerEdit', params: {id: customer.id}}">
                            <font-awesome-icon icon="edit"></font-awesome-icon> Modificar
                        </b-button>
                    </div>
                </template>
                <b-row class="mt-5">
                    <b-col cols="12" md="6" lg="6">
                        <b-row>
                            <b-col cols="5" md="5" class="text-right"><b>Razón social: </b></b-col>
                            <b-col cols="7" md="5" class="text-left">{{ customer.legalName }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5" md="5" class="text-right"><b>RFC: </b></b-col>
                            <b-col cols="7" md="5" class="text-left">{{ customer.taxId !== '' ? customer.taxId : 'Sin registro' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5" md="5" class="text-right"><b>Correo: </b></b-col>
                            <b-col cols="7" md="5" class="text-left">{{ customer.email !== '' ? customer.email : 'Sin registro' }}</b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-row>
                            <b-col cols="5" md="5" class="text-right"><b>Teléfono 1: </b></b-col>
                            <b-col cols="7" md="5" class="text-left">{{ customer.phone1 !== '' ? customer.phone1 : 'Sin registro' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5" md="5" class="text-right"><b>Teléfono 2: </b></b-col>
                            <b-col cols="7" md="5" class="text-left">{{ customer.phone2 !== '' ? customer.phone2 : 'Sin registro' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5" md="5" class="text-right"><b>Dirección: </b></b-col>
                            <template v-if="customer.address.id === 0">
                                <b-col cols="7" md="5" class="text-left">{{ 'Sin registro' }}</b-col>
                            </template>
                            <template v-else>
                                <b-col cols="7" md="5" class="text-left">
                                    {{ customer.address.street }} {{customer.address.extNumber }} {{ customer.address.intNumber }}
                                </b-col>
                                <b-col offset="5" cols="7" md="5" class="text-left">
                                    {{ customer.address.neighborhood }}<template v-if="customer.address.borough || customer.address.city">,</template>
                                    {{customer.address.borough }}<template v-if="customer.address.city">,</template> {{ customer.address.city }}
                                </b-col>
                                <b-col offset="5" cols="7" md="5" class="text-left">
                                    {{ customer.address.state }}, {{customer.address.country }} {{ customer.address.zipCode }}
                                </b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-card class="m-4" no-body>
                            <b-tabs content-class="mt-3" card>
                                <b-tab title="Usuarios" active no-body lazy class="px-4 pb-4">
                                    <UserIndex :settings="settings" :membership="membership" :userType="PORTAL_USER"
                                               :customer="customer" @get-setting="$parent.loadData()"></UserIndex>
                                </b-tab>
                                <b-tab title="Grupos" no-body lazy class="px-4 pb-4">
                                    <GroupIndex :settings="settings" :membership="membership" :customer="customer"></GroupIndex>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
    </b-overlay>
</template>

<script>
import UserIndex from '../User/Index';
import GroupIndex from '../Group/Index';
import { customerUrl } from '@routes';
import * as constants from '@constants';

export default {
    props: {
        settings: Object,
        membership: Object
    },
    data() {
        return {
            customer: {
                id: 0,
                legalName: '',
                taxId: '',
                email: '',
                phone1: '',
                phone2: '',
                address: {
                    id: 0,
                    street: '',
                    intNumber: '',
                    extNumber: '',
                    neighborhood: '',
                    borough: '',
                    city: '',
                    state: '',
                    country: '',
                    zipCode: '',
                    alias: ''
                },
                publications: [],
                groups: [],
                users: []
            },
            isLoading: false
        };
    },
    components: {
        UserIndex,
        GroupIndex
    },
    created() {
        this.loadData();
        this.$parent.loadData();
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.axios.get(customerUrl(), {
                params: {
                    customerId: this.$route.params.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let customer = response.data.customer;

                    this.customer.id = customer.id;
                    this.customer.legalName = customer.legalName;
                    this.customer.taxId = customer.taxId;
                    this.customer.email = customer.email;
                    this.customer.phone1 = customer.phone1;
                    this.customer.phone2 = customer.phone2;

                    this.customer.publications = customer.publications;
                    this.customer.groups = customer.groups;
                    this.customer.users = customer.users;

                    if ('address' in customer) {
                        this.customer.address.id = customer.address.id;
                        this.customer.address.street = customer.address.street;
                        this.customer.address.intNumber = customer.address.intNumber;
                        this.customer.address.extNumber = customer.address.extNumber;
                        this.customer.address.neighborhood = customer.address.neighborhood;
                        this.customer.address.borough = customer.address.borough;
                        this.customer.address.city = customer.address.city;
                        this.customer.address.state = customer.address.state;
                        this.customer.address.country = customer.address.country;
                        this.customer.address.zipCode = customer.address.zipCode;
                        this.customer.address.alias = customer.address.alias;
                    }
                }
            }).finally(() => {
                this.isLoading = false;

                this.$emit('update-breadcrumb-items', [
                    {
                        text: 'Clientes',
                        to: { name: 'Customer' }
                    },
                    {
                        text: this.customer.legalName,
                        active: true
                    }
                ]);
            });
        }
    },
    computed: {
        BACK_OFFICE_USER() {
            return constants.BACK_OFFICE_USER;
        },
        PORTAL_USER() {
            return constants.PORTAL_USER;
        }
    }
}
</script>

<style scoped>

</style>